export const PORTAL_TRANSIT_MS = 3800;
export const CORE_PORTAL_TRANSIT_MS = 6800;
export const WARDEN_PORTAL_TRANSIT_MS = 5200;
export const PORTAL_ENTRY_MS = 1550;

// Each route changes the tunnel's architecture, particles, shader and flight.
const PORTAL_WARP_PROFILES = {
  Recovery: {
    id: 'recovery',
    label: 'THE LIVING CURRENT',
    description: 'Follow the healing pulse through a living lattice.',
    primary: '#74ffc3',
    secondary: '#caffed',
    mode: 0,
    contour: 'Recovery',
    token: 'cross',
    twist: 0.11,
    bank: 0.045,
    sway: 0.12,
  },
  Treasure: {
    id: 'treasure',
    label: 'THE GOLDEN PASSAGE',
    description: 'Beyond the vault rings, forgotten riches are waiting.',
    primary: '#ffd16b',
    secondary: '#fff0bd',
    mode: 1,
    contour: 'Treasure',
    token: 'shard',
    twist: 0.015,
    bank: 0.055,
    sway: 0.1,
  },
  'Bonus Relic': {
    id: 'relic',
    label: 'THE PRISM VEIN',
    description: 'An ancient power refracts the path ahead.',
    primary: '#c78aff',
    secondary: '#78efff',
    mode: 2,
    contour: 'Bonus Relic',
    token: 'prism',
    twist: 0.075,
    bank: 0.12,
    sway: 0.2,
  },
  Salvage: {
    id: 'salvage',
    label: 'THE WRECKAGE RUN',
    description: 'Thread the broken ribs of a forgotten relay.',
    primary: '#99bfd6',
    secondary: '#ffaf67',
    mode: 3,
    contour: 'Salvage',
    token: 'scrap',
    twist: 0.008,
    bank: -0.07,
    sway: 0.16,
  },
  Sanctuary: {
    id: 'sanctuary',
    label: 'THE STILLWATER VEIL',
    description: 'Quiet auroras carry you between the stars.',
    primary: '#80ece3',
    secondary: '#e7ffbd',
    mode: 4,
    contour: 'Sanctuary',
    token: 'mote',
    twist: 0.035,
    bank: 0.025,
    sway: 0.08,
  },
  Trial: {
    id: 'trial',
    label: 'THE CRUCIBLE',
    description: 'Cross the burning gates. Keep your signal alive.',
    primary: '#ff896f',
    secondary: '#ffd478',
    mode: 5,
    contour: 'Trial',
    token: 'blade',
    twist: -0.035,
    bank: -0.12,
    sway: 0.18,
  },
  Armory: {
    id: 'armory',
    label: 'THE ION RAIL',
    description: 'Ride the blue fire of an ancient weapons conduit.',
    primary: '#79b8ff',
    secondary: '#a5f8ff',
    mode: 6,
    contour: 'Armory',
    token: 'bolt',
    twist: 0,
    bank: 0.035,
    sway: 0.06,
  },
  Shrine: {
    id: 'shrine',
    label: 'THE ASTRAL CATHEDRAL',
    description: 'Pass beneath the constellations of a lost civilization.',
    primary: '#f0a0e6',
    secondary: '#ffe5b6',
    mode: 7,
    contour: 'Shrine',
    token: 'star',
    twist: -0.045,
    bank: 0.08,
    sway: 0.14,
  },
  Supply: {
    id: 'supply',
    label: 'THE EMERALD CONVOY',
    description: 'The supply beacons are still guiding travelers home.',
    primary: '#c4ed89',
    secondary: '#e8fff5',
    mode: 8,
    contour: 'Supply',
    token: 'cargo',
    twist: 0,
    bank: -0.025,
    sway: 0.08,
  },
  Anomaly: {
    id: 'anomaly',
    label: 'THE IMPOSSIBLE CURRENT',
    description: 'Space folds. The only way through is forward.',
    primary: '#b69aff',
    secondary: '#ff74d7',
    mode: 9,
    contour: 'Anomaly',
    token: 'fracture',
    twist: 0.16,
    bank: 0.19,
    sway: 0.32,
  },
  Core: {
    id: 'core',
    label: 'THE LAST EVENT HORIZON',
    description:
      'Every broken signal leads here. Cross the heart of the storm.',
    primary: '#be88ff',
    secondary: '#ff587e',
    mode: 10,
    contour: 'Core',
    token: 'core-shard',
    twist: 0.085,
    bank: 0.15,
    sway: 0.25,
  },
  Warden: {
    id: 'warden',
    label: 'THE FRACTURED CITADEL',
    description: 'The Warden is pulling the passage apart. Hold your course.',
    primary: '#ffb26d',
    secondary: '#ff628b',
    mode: 11,
    contour: 'Warden',
    token: 'rift-blade',
    twist: -0.12,
    bank: -0.17,
    sway: 0.28,
  },
};

export const getPortalWarpProfile = (route = {}) =>
  PORTAL_WARP_PROFILES[
    route.name === 'The Rift Warden' ? 'Warden' : route.kind
  ] || PORTAL_WARP_PROFILES.Anomaly;

export const getPortalTransitDuration = (route) =>
  getPortalWarpProfile(route).id === 'core'
    ? CORE_PORTAL_TRANSIT_MS
    : getPortalWarpProfile(route).id === 'warden'
    ? WARDEN_PORTAL_TRANSIT_MS
    : PORTAL_TRANSIT_MS;

export const getPortalWarpProgress = (elapsed, duration) => {
  const start = PORTAL_ENTRY_MS / 1000;
  return Math.max(
    0,
    Math.min(1, (elapsed - start) / (duration / 1000 - start - 0.35))
  );
};
